import _ from 'lodash';
import * as types from './reportActionTypes';

export default (state = [], action) => {
    switch(action.type) {
        case types.LOAD_REPORTS_SUCCESS:
            return _.orderBy(action.reports, report => report.generated, "desc");
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reports/reportsReducer.js